var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face{font-family:GTSuper;src:url(" + escape(require("./GT-Super-Display-Super.woff2")) + ") format(\"woff2\");font-weight:900;font-style:normal}@font-face{font-family:GTSuper;src:url(" + escape(require("./GT-Super-Display-Super-Italic.woff2")) + ") format(\"woff2\");font-weight:900;font-style:italic}", ""]);

// exports
